import React, { useState, useEffect } from "react";
import "./ArticleIndustryPage.css";
import ContactUs from "../ContactUs/ContactUs";
//import Carousel from "../Carousel/Carousel";
const ArticleIndustryPage= (props)=>{
    const [linksState, setLinksState] = useState([]);
    const [richTextTitle,setRichTextTitle]=useState('');
    const [richText,setRichText]=useState('');
    const [toggleBtn,setToggleBtn]=useState([]);
    const [openToggle, setOpenToggle] = useState(false);
    const [carouselItems,setCarouselItems]=useState({});
    const [subTitleCarousel, setSubTitleCarousel] = useState('');
    const [isMobile, setIsMobile] = useState(true);

    useEffect(()=>{
       if(window.innerWidth > 768){
           setIsMobile(false);
       }
        let tempLinksArray = [];
        let tempCarouselItems = [];
        let tempItems = props.items.filter((item,idx)=>{
        if(item.MashanIsActive){
            
            if(!!item.ContainerTitle && !item.MashanTopDesktopImage  && !item.MashanContainerLink ){
                setToggleBtn(item.ContainerTitle);
                return  false;
            }
            //links
            else if(!item.MashanTopDesktopImage && !!item.MashanContainerLink && !!item.MashanContainerLink.NavigateUrl && !!item.MashanContainerLink.Text ){
                    tempLinksArray.push(item)
                   return true;
            }
            //Rich Text
            else if(!item.MashanContainerLink && !item.MashanTopDesktopImage && !!item.RichTextContainer && item.RichTextContainer.length > 10 ){
                setRichText(item.RichTextContainer);
                setRichTextTitle(item.LinkTitle);
                return false;
            }
            //   sub  Carousel Items
            
              else if(!!item.MashanTopDesktopImage && (!item.RichTextContainer || item.RichTextContainer.length < 16 )){
                let categoryTitle = item.ContainerTitle.split('-');
                let  categoryTitleFirstItem= categoryTitle[0].trim();
                if(!(categoryTitleFirstItem in tempCarouselItems)){
                    if(Object.keys(tempCarouselItems).length ===0){
                        setSubTitleCarousel(categoryTitleFirstItem);
                    }
                    tempCarouselItems[categoryTitleFirstItem]=[];
                }
                  tempCarouselItems[categoryTitleFirstItem].push({key:categoryTitle[1].trim(),value:item});
                  return false;
            }
        }
        else{return false;}
    });
    
        GetCategoryByQueryString(Object.keys( tempCarouselItems));
        setCarouselItems(tempCarouselItems);
        setLinksState(tempItems);

    }   ,[]);
    const GetCategoryByQueryString = (categoryTitleArr)=>{
       
       let tempCategry='';
       if(!!location.hash && categoryTitleArr.length>0){
            tempCategry = location.hash.substring(1).toLowerCase();
            for(let arrI=0;arrI<categoryTitleArr.length;arrI++){
                if(categoryTitleArr[arrI].toLowerCase().indexOf(tempCategry)>-1){
                    setSubTitleCarousel(categoryTitleArr[arrI]);
                    break;
                }
            }
        }
    }
    const LinksButtons=(link)=>{
        if(!!link){
            window.location.href = link;
        }
    };
    const articleIndustryLinks = linksState.map((item,idx)=>{
            let tempBtnClass =  idx==0 ? 'btn-primary': 'btn-outline-primary';
                
            return ( <button key={idx+'btn-link'} type='button' className={'qa-btn btn '+tempBtnClass}
                        onClick={e=>{LinksButtons(item.MashanContainerLink.NavigateUrl)}}>
                        {item.MashanContainerLink.Text}</button>
                        )
                });
    const ToggleContactUsForm =(e)=>{
        
            if(e.target.className.indexOf('toggle-open')>-1){
                e.target.classList.value='toggle-icon';
                e.target.classList.add('toggle-close');
                setOpenToggle(true);
            }
            else{
                e.target.classList.value='toggle-icon';
                e.target.classList.add('toggle-open');
                setOpenToggle(false);
            }
    };
    const ChangeSubCategory=(item)=>{
        window.location.href = item[0].value.MashanContainerLink.NavigateUrl;
    };
    const LinkSubCategory=(link)=>{
        
        if(!!link){
            window.location.href = link;
        }
    };
    return <div className={'article-industry-page-warpper row col-12 col-md-12 nav-section'} id={`nav-section-0`}>
        <div className='col-12 col-md-3 col-xl-2 sub-category-list'>
                {Object.keys(carouselItems).map((item,idx)=>{
                    
                    let tempClassName= 'sub-category-list-link';
                    tempClassName = item == subTitleCarousel ? tempClassName+ ' active':tempClassName;
                    return (<a key={item+idx} className={tempClassName} onClick={e=>{ChangeSubCategory(carouselItems[item])}}>
                      {item}
                    </a>);
                })}
        </div>
    <div className={'article-industry-main-page col-12 col-md-9 col-xl-8'} >
                    <div className={'col-12 col-md-12 article-industry-title'} >
                           {subTitleCarousel} 
                    </div>
                    <div className={'col-12 col-md-12 article-industry-free-text'} >
                          {props.freeText}
                    </div>
                    <div className={'col-12 col-md-12 carousel-sub-category'} >
                    { !!subTitleCarousel && carouselItems[subTitleCarousel].map((item,idx)=>{
                        let tempLink = !!item.value.MashanTopDesktopImage.Hyperlink ? item.value.MashanTopDesktopImage.Hyperlink:'';
                        let pointerType= !!tempLink ? {cursor: 'pointer'}:{cursor: 'auto'} ;
                            return (<div className={'col-10 col-sm-5 col-md-3 col-xl-4 m-md-2'} key={idx} style={pointerType}
                                        onClick={e=>{ LinkSubCategory(item.value.MashanTopDesktopImage.Hyperlink)}}
                                        >
                                     
                                            <div className={'category-slider-img'}
                                            // col-11 col-xl-12'} 
                                                style={{backgroundImage: !!item.value.MashanTopDesktopImage ? 
                                                    `url(${item.value.MashanTopDesktopImage.ImageUrl+(isMobile? '?RenditionID=16':'?RenditionID=15')})`: ''}}
                                            ></div>
                                            <div className={'col-11'} >{item.key}</div>
                                        </div>);
                            })}                     
                    </div>
                    
                <div className={' col-12 col-md-12 links-warpper'}>
                    {articleIndustryLinks}
                </div>
                <div className={'rich-title-warpper  col-12 col-xl-8'} >
                    {richTextTitle}
                </div>
                <div className={'rich-text-warpper  col-12 col-xl-9'} dangerouslySetInnerHTML={{__html:richText}}>
                </div>
                <div className={'toggle-warpper  col-12 col-xl-12'} >
                    {toggleBtn}
                     <div className={'toggle-icon toggle-open'} onClick={ToggleContactUsForm}></div> 
                     {openToggle && <div className='col-12 col-xl-8'><div className='contact-us form'>
                         <ContactUs mainURL={props.mainURL} showNote={false} subject={subTitleCarousel}/>
                         </div></div>}
                </div>
                </div>
    </div>   
}
export default ArticleIndustryPage;